export default __webpack_public_path__ + "static/media/outside.540404fe.png";